.TextButton4166777016__root {
    -st-states:
      size(enum(tiny, small, medium)),
      weight(enum(thin, normal, bold)),
      skin(enum(standard, premium, dark)),
      underline(enum(onMouseHover, always, none)),
      prefix,
      suffix,
      disabled;
  font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--Typography42144321-wix-font-weight-medium, 530);
  -webkit-font-smoothing: antialiased;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    text-decoration: none;
    background-color: transparent;
    border: none;
    padding: 0;
}

.TextButton4166777016__root svg {
  display: block;
}

/* Size */
.TextButton4166777016__root.TextButton4166777016---size-4-tiny {
    font-size: 12px;
    line-height: 12px;
}

.TextButton4166777016__root.TextButton4166777016---size-5-small {
    font-size: 14px;
    line-height: 18px;
}

.TextButton4166777016__root.TextButton4166777016---size-6-medium {
    font-size: 16px;
    line-height: 18px;
}

/* Weight */
.TextButton4166777016__root.TextButton4166777016---weight-4-thin {
  font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--Typography42144321-wix-font-weight-regular, 400);
  -webkit-font-smoothing: antialiased;
}

/* Skin */
.TextButton4166777016__root.TextButton4166777016---skin-8-standard {
  color: #116dff;
}

.TextButton4166777016__root.TextButton4166777016---skin-4-dark {
  color: #000624;
}

.TextButton4166777016__root.TextButton4166777016---skin-7-premium {
  color: #9a27d5;
}

/* Affix */
.TextButton4166777016__root.TextButton4166777016--prefix .TextButton4166777016__text {
    margin-inline-start: 4px;
}


.TextButton4166777016__root.TextButton4166777016--suffix .TextButton4166777016__text {
    margin-inline-end: 4px;
}

.TextButton4166777016__root.TextButton4166777016--prefix,
.TextButton4166777016__root.TextButton4166777016--suffix{
    vertical-align: middle;
}

/* Underline */
.TextButton4166777016__root:not(.TextButton4166777016--disabled).TextButton4166777016---underline-12-onMouseHover:hover
{
  text-decoration: underline;
}

.TextButton4166777016__root.TextButton4166777016---underline-6-always {
  text-decoration: underline;
}

/* Disabled */
.TextButton4166777016__root.TextButton4166777016--disabled{
  color: #898989;
  cursor: initial;
}

/* Hover */
.TextButton4166777016__root:not(.TextButton4166777016--disabled):hover.TextButton4166777016---skin-8-standard {
  color: #5999ff;
}

/* st-namespace-reference="../../../../src/atoms/TextButton/TextButton.st.css" */